import type { OpcaoPerfilDePermissao } from '../catalogo-perfil-de-permissao.tipos'

export type ListarOpcoesPerfilDePermissaoRepositorio = (
  sinal: AbortSignal,
) => Promise<readonly OpcaoPerfilDePermissao[]>

export const criarCasoDeUsoListarOpcoesPerfilDePermissao = (
  repositorio: ListarOpcoesPerfilDePermissaoRepositorio,
): ListarOpcoesPerfilDePermissaoRepositorio => async (sinal) => repositorio(sinal)
